import { render, staticRenderFns } from "./OperaShopApprovalWindow.vue?vue&type=template&id=cc64848a&scoped=true&"
import script from "./OperaShopApprovalWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopApprovalWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopApprovalWindow.vue?vue&type=style&index=0&id=cc64848a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc64848a",
  null
  
)

export default component.exports